import React, { useState, useEffect } from 'react';
import './CookieManager.scss';

const CookieManager = ({ isOpen, onClose }) => {
  const [preferences, setPreferences] = useState({
    essential: true,
    analytics: false,
    preferences: false,
    marketing: false
  });

  useEffect(() => {
    // Load saved preferences when modal opens
    if (isOpen) {
      const savedConsent = localStorage.getItem('cookie-consent');
      if (savedConsent) {
        const { preferences: savedPreferences } = JSON.parse(savedConsent);
        setPreferences(savedPreferences);
      }
    }
  }, [isOpen]);

  const handleSave = () => {
    localStorage.setItem('cookie-consent', JSON.stringify({
      preferences,
      timestamp: new Date().toISOString()
    }));
    updateCookiePreferences(preferences);
    onClose();
  };

  const updateCookiePreferences = (prefs) => {
    // Implement actual cookie management here
    if (!prefs.analytics) {
      // Disable analytics cookies
    }
    if (!prefs.marketing) {
      // Disable marketing cookies
    }
  };

  const handlePreferenceChange = (category) => {
    if (category === 'essential') return; // Cannot change essential cookies
    setPreferences(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  if (!isOpen) return null;

  return (
    <div className="cookie-manager-overlay">
      <div className="cookie-manager">
        <div className="cookie-manager-header">
          <h2>Cookie Preferences</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>

        <div className="cookie-manager-content">
          <p>
            Manage your cookie preferences below. Essential cookies cannot be disabled as they are 
            required for the website to function properly.
          </p>

          <div className="cookie-categories">
            <div className="cookie-category">
              <div className="category-header">
                <label>
                  <input 
                    type="checkbox" 
                    checked={preferences.essential} 
                    disabled={true}
                  />
                  <span>Essential Cookies</span>
                </label>
              </div>
              <p>These cookies are necessary for the website to function and cannot be switched off.</p>
            </div>

            <div className="cookie-category">
              <div className="category-header">
                <label>
                  <input 
                    type="checkbox" 
                    checked={preferences.analytics} 
                    onChange={() => handlePreferenceChange('analytics')}
                  />
                  <span>Analytics Cookies</span>
                </label>
              </div>
              <p>These cookies allow us to count visits and traffic sources to measure and improve site performance.</p>
            </div>

            <div className="cookie-category">
              <div className="category-header">
                <label>
                  <input 
                    type="checkbox" 
                    checked={preferences.preferences} 
                    onChange={() => handlePreferenceChange('preferences')}
                  />
                  <span>Preference Cookies</span>
                </label>
              </div>
              <p>These cookies enable the website to remember your preferences and personalize your experience.</p>
            </div>

            <div className="cookie-category">
              <div className="category-header">
                <label>
                  <input 
                    type="checkbox" 
                    checked={preferences.marketing} 
                    onChange={() => handlePreferenceChange('marketing')}
                  />
                  <span>Marketing Cookies</span>
                </label>
              </div>
              <p>These cookies may be set by our advertising partners to build a profile of your interests.</p>
            </div>
          </div>
        </div>

        <div className="cookie-manager-footer">
          <button className="btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn-primary" onClick={handleSave}>Save Preferences</button>
        </div>
      </div>
    </div>
  );
};

export default CookieManager; 